export default {
  id: null,
  salesOrderBk: null,
};
